import { isAxiosError } from './guards'

const DOCTYPE_REGEXP = /<!doctype/i

type ErrorResponse =
  | string
  | { error?: string | { message: string }; message?: string }

/**
 * `parseErrorMessage` parses error argument
 * and returns error message as string
 */
export const parseErrorMessage = (
  error: unknown,
  options?: { stringifyResponse: boolean }
) => {
  if (isAxiosError<ErrorResponse>(error)) {
    if (typeof error.response?.data === 'string') {
      // In case `data` is empty or error message is a response from
      // proxy server (the `data` property contains whole HTML document),
      // we will return error message based on the `statusText`.
      return error.response.data.length === 0 ||
        DOCTYPE_REGEXP.test(error.response.data)
        ? `${error.message}: ${error.response.statusText}`
        : error.response.data
    }
    if (options?.stringifyResponse) {
      return JSON.stringify(error.response?.data, null, 2)
    }
    if (typeof error.response?.data?.message === 'string') {
      return error.response.data.message
    }
    return typeof error.response?.data?.error === 'object'
      ? error.response?.data?.error?.message
      : error.response?.data?.error || error.message
  }
  if (error instanceof Error) {
    return error.message
  }
  if (typeof error === 'string') {
    return error
  }
  return 'Unexpected error occurred'
}
